import ReportingDone from './component.jsx'
export default ReportingDone
